import { useApiOperatorDashboardStatsGet } from "@fllite/api";

import {
  DashboardMetric,
  DashboardPeriod,
  OperatorDashboardStats,
  TimeSavedDuration,
} from "@/components/Dashboard/Dashboard/types";

const normalizeMetric = (raw: unknown): DashboardMetric => {
  const value = (raw ?? {}) as Partial<DashboardMetric>;
  return {
    current: value.current ?? null,
    previous: value.previous ?? null,
    deltaPercent: value.deltaPercent ?? null,
  };
};

const normalizeDuration = (raw: unknown): TimeSavedDuration => {
  const value = (raw ?? {}) as Partial<TimeSavedDuration>;
  return {
    hours: value.hours ?? 0,
    minutes: value.minutes ?? 0,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const normalize = (raw: any, period: DashboardPeriod): OperatorDashboardStats => ({
  period,
  proposals: {
    count: normalizeMetric(raw?.proposals?.count),
    amount: normalizeMetric(raw?.proposals?.amount),
  },
  bookedTrips: {
    count: normalizeMetric(raw?.bookedTrips?.count),
    value: normalizeMetric(raw?.bookedTrips?.value),
    averageMargin: normalizeMetric(raw?.bookedTrips?.averageMargin),
    conversionRate: normalizeMetric(raw?.bookedTrips?.conversionRate),
  },
  timeSaved: {
    duration: normalizeDuration(raw?.timeSaved?.duration),
    previousDuration:
      raw?.timeSaved?.previousDuration != null
        ? normalizeDuration(raw.timeSaved.previousDuration)
        : null,
    deltaPercent: raw?.timeSaved?.deltaPercent ?? null,
  },
});

export const useOperatorDashboardStats = (period: DashboardPeriod) => {
  // The first argument is the URL query params object — passing options here
  // sent `?query=…&request=…` instead of `?period=…`, so the backend always
  // fell back to its default (PERIOD_WEEK) regardless of selection.
  const { data, isLoading } = useApiOperatorDashboardStatsGet<unknown>({
    period,
  });

  return {
    stats: data ? normalize(data, period) : undefined,
    isLoading,
  };
};
